import { FormFieldType } from './formFieldType'
import { FormFieldSelectOption } from '../base/formFieldSelectOption' // eslint-disable-line no-unused-vars
export { FormFieldType, FormFieldSelectOption }

/**
 * A field in a form used in forms.
 *
 * @export
 * @class FormField
 */
export class FormField {
  /**
   * Creates an instance of FormField.
   * @param {any} type The type of the the field.
   * @param {string} identifier The field's identifier. Used as the name/identifier for submission.
   * @param {string} label The display label for the form.
   * @param {string} [placeholder=''] The placeholder for the input.
   * @param {string} [defaultValue=''] The default value for the input.
   * @param {[FormFieldSelectOptions]} [options=[]] For some types, this field contains possible values. For others, it's ignored.
   * @param {boolean} [multiselect=true] For select inputs, do we allow multiple options? For checkbox or radio, which one do we use?
   * @param {boolean} [required=true] Is this field required?
   * @param {boolean} showSelectAll Do we show select all for multiselect types?
   * @param {Array} tokenizers An array of tokenizers to use for displaying tokens in the UI.
   * @param {boolean} inline Do we show this form in its own row or not?
   * @param {String} fileTypes A string containing a mime type or comma seperated mime types. "image/*"
   * @memberof FormField
   */
  constructor ({ type = FormFieldType.TEXT, identifier, label, placeholder = '', defaultValue = '', options = [], multiselect = false, required = true, showSelectAll = false, tokenizers = [], inline = false, fileTypes = undefined, layout } = {}) {
    this.identifier = identifier
    this.rawType = type
    this.type = this.stringifiedType(type)
    this.label = label
    this.required = required
    this.placeholder = placeholder
    // multiselect needs array as default value, so add/remove behave as intended.
    this.defaultValue = (multiselect === true && !Array.isArray(defaultValue)) ? [] : defaultValue
    this.options = options
    this.multiselect = multiselect
    this.keypath = this.identifier
    this.showSelectAll = showSelectAll
    this.tokenizers = tokenizers
    this.inline = inline
    this.fileTypes = fileTypes
    this.layout = layout
  }

  /**
   * Pulls out the the field type.
   *
   * @param {any} fieldType The raw type to confirm.
   * @returns The string representation of the field type.
   * @memberof FormField
   */
  stringifiedType (fieldType) {
    if (fieldType) {
      const metadata = FormFieldType.properties[fieldType]
      if (metadata && metadata.description) {
        return metadata.description
      }
    }

    // Use the default to match how the MDN docs describe undefined types as working.
    // See: https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types
    return 'text'
  }
}
